import {useCallback, useState} from 'react'
import {Link, useNavigate} from 'react-router-dom'
import {useLang} from '../../../../_metronic/i18n/Metronici18n'
import {ActionsCell} from '../../../componet/Menu'
import {RootState, useDispatch, withToastr} from '../../../store'
import {deleteProductAction} from '../../../store/vender/products/thunk'
import {Language} from '../../../types'
import {handleClickSelected} from '../../../utils/sortTable'
import {RowItemProps} from './types'
import {useTranslation} from 'react-i18next'
import {useSelector} from 'react-redux'
import {Box, Stack, Typography} from '@mui/material'
import VariationRow from './VariationRow'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import {toast} from 'react-toastify'
import ViewBtn from './View'
import Product from '../../../Api/product'
import SimpleLoading from '../../customTable/SimpleLoading'
export const RowItem = (props: any) => {
  const [isLoadingDelete, setIsLoadingDelete] = useState(false)
  const navigate = useNavigate()

  const {item, i, setRows} = props

  const handelDelete = () => {
    Product.destroyReview(
      item.id,
      () => {
        setRows((prev: any) => prev.filter((e: any) => e.id !== item.id))
      },
      setIsLoadingDelete
    )
  }
  const store = useSelector((state: RootState) => state.vender)
  return (
    <>
      <tr>
        <td className=''>{i + 1}</td>

        <td className=''>
          <Stack
            onClick={() => {
              navigate(`/customer/details/${item.id}`)
            }}
            minWidth={'400px'}
            gap='16px'
            direction={'row'}
          >
            <img
              style={{width: '50px', height: '50px', borderRadius: '50%'}}
              src={item.user.image}
              alt=''
            />
            <Stack gap='5px'>
              <Stack gap='8px' direction={'row'}>
                <Typography
                  sx={{color: '#3F4254', fontSize: '15px', fontWeight: '600', lineHeight: '18px'}}
                >
                  {item.user.full_name}
                </Typography>
                <Typography
                  sx={{color: '#9D9DA6', fontSize: '12px', fontWeight: '400', lineHeight: '18px'}}
                >
                  {item.time}
                </Typography>
              </Stack>
              <Typography
                sx={{color: '#65656A', fontSize: '14px', fontWeight: '400', lineHeight: '18px'}}
              >
                {item.comment}
              </Typography>
            </Stack>
          </Stack>
        </td>
        <td className=''>{item.product.name}</td>

        <td>
          <div className='rating '>
            {Array.from({length: item.rating}, (_, i) => (
              <div className='rating-label checked'>
                <span className='svg-icon svg-icon-2'>
                  <svg
                    width='24'
                    height='24'
                    viewBox='0 0 24 24'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M11.1359 4.48359C11.5216 3.82132 12.4784 3.82132 12.8641 4.48359L15.011 8.16962C15.1523 8.41222 15.3891 8.58425 15.6635 8.64367L19.8326 9.54646C20.5816 9.70867 20.8773 10.6186 20.3666 11.1901L17.5244 14.371C17.3374 14.5803 17.2469 14.8587 17.2752 15.138L17.7049 19.382C17.7821 20.1445 17.0081 20.7069 16.3067 20.3978L12.4032 18.6777C12.1463 18.5645 11.8537 18.5645 11.5968 18.6777L7.69326 20.3978C6.99192 20.7069 6.21789 20.1445 6.2951 19.382L6.7248 15.138C6.75308 14.8587 6.66264 14.5803 6.47558 14.371L3.63339 11.1901C3.12273 10.6186 3.41838 9.70867 4.16744 9.54646L8.3365 8.64367C8.61089 8.58425 8.84767 8.41222 8.98897 8.16962L11.1359 4.48359Z'
                      fill='currentColor'
                    />
                  </svg>
                </span>
              </div>
            ))}
            {Array.from({length: 5 - item.rate}, (_, i) => (
              <div className='rating-label'>
                <span className='svg-icon svg-icon-2'>
                  <svg
                    width='24'
                    height='24'
                    viewBox='0 0 24 24'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M11.1359 4.48359C11.5216 3.82132 12.4784 3.82132 12.8641 4.48359L15.011 8.16962C15.1523 8.41222 15.3891 8.58425 15.6635 8.64367L19.8326 9.54646C20.5816 9.70867 20.8773 10.6186 20.3666 11.1901L17.5244 14.371C17.3374 14.5803 17.2469 14.8587 17.2752 15.138L17.7049 19.382C17.7821 20.1445 17.0081 20.7069 16.3067 20.3978L12.4032 18.6777C12.1463 18.5645 11.8537 18.5645 11.5968 18.6777L7.69326 20.3978C6.99192 20.7069 6.21789 20.1445 6.2951 19.382L6.7248 15.138C6.75308 14.8587 6.66264 14.5803 6.47558 14.371L3.63339 11.1901C3.12273 10.6186 3.41838 9.70867 4.16744 9.54646L8.3365 8.64367C8.61089 8.58425 8.84767 8.41222 8.98897 8.16962L11.1359 4.48359Z'
                      fill='currentColor'
                    />
                  </svg>
                </span>
              </div>
            ))}
          </div>
        </td>
        <td className=' pe-0' data-order='Published'>
          <div style={{padding: '7px 16px'}} className='badge badge-light-success'>
            {'Published'}
          </div>
        </td>

        <td style={{minWidth: '120px'}}>
          {isLoadingDelete ? (
            <SimpleLoading />
          ) : (
            <ActionsCell onDelete={handelDelete} deleteMsg={'deleteComment'} />
          )}
        </td>
      </tr>
    </>
  )
}
